import { Campaign } from 'domains/campaigns/types';
import { CampaignStatus } from 'models/enums';
import SendingTestStatus from './StatusComponents/SendingTestStatus';
import PendingWinnerSelectionStatus from './StatusComponents/PendingWinnerSelectionStatus';
import WinnerDeclaredStatus from './StatusComponents/WinnerDeclaredStatus';
import WinnerScheduledStatus from './StatusComponents/WinnerScheduledStatus';
import SendingWinnerStatus from './StatusComponents/SendingWinnerStatus';
import WinnerSentStatus from './StatusComponents/WinnerSentStatus';
import WinnerFailedStatus from './StatusComponents/WinnerFailedStatus';
import WinnerStoppedStatus from './StatusComponents/WinnerStoppedStatus';

type AbTestingStatusDetailsProps = {
    campaign: Campaign;
    contentPreviewNodeId?: string | number;
    handlePreviewClick: (contentNodeId: number) => void;
};

const AbTestingStatusDetails = ({
    campaign,
    contentPreviewNodeId,
    handlePreviewClick,
}: AbTestingStatusDetailsProps) => {
    // Only render if campaign has AB test configuration
    if (!campaign.abTestConfig) {
        return null;
    }

    // Route to the appropriate status component
    switch (campaign.status) {
        case CampaignStatus.SENDING:
        case CampaignStatus.SENDING_AB_TEST:
            return <SendingTestStatus campaign={campaign} />;
        case CampaignStatus.PENDING_WINNER_SELECTION:
            return <PendingWinnerSelectionStatus campaign={campaign} />;
        case CampaignStatus.SCHEDULED:
            return null;
        case CampaignStatus.COMPLETED:
            return <PendingWinnerSelectionStatus campaign={campaign} />;
        case CampaignStatus.WINNER_DECLARED:
            return <WinnerDeclaredStatus campaign={campaign} />;
        case CampaignStatus.WINNER_SCHEDULED:
            return <WinnerScheduledStatus campaign={campaign} />;
        case CampaignStatus.SENDING_WINNER:
            return <SendingWinnerStatus campaign={campaign} />;
        case CampaignStatus.WINNER_SENT:
            return <WinnerSentStatus campaign={campaign} />;
        case CampaignStatus.WINNER_FAILED:
            return <WinnerFailedStatus campaign={campaign} />;
        case CampaignStatus.WINNER_STOPPED:
            return <WinnerStoppedStatus campaign={campaign} />;
        case CampaignStatus.FAILED:
            // Regular campaign failure, not AB test specific
            return null;
        default:
            return null;
    }
};

export default AbTestingStatusDetails;
